import React from 'react'
import { Box, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from '@mui/material'
import ForumIcon from '@mui/icons-material/Forum'

const FooterCol3 = (props) => {
  return (
    <Paper sx={{m:1, p: 1,}}>
      <Typography component="h3" fontWeight={600} variant="h6">Explore</Typography>
      <List>
        {/* Get Started */}
        <ListItem disablePadding>
          <ListItemButton href="/posts/getting-started/">
            <ListItemIcon>
              <Box
                alt="Personal Architect Logomark"
                component="img"
                src={
                  process.env.NODE_ENV === 'development' ? 
                    "/assets/svg/marks/primary/personal-architect.svg" : 
                    "/wp-content/themes/personal-architect/assets/svg/marks/primary/personal-architect.svg"
                }
                sx={{width: 24, height: 24,}}
              />
            </ListItemIcon>
            <ListItemText primary="Get Started" />
          </ListItemButton>
        </ListItem>
        {/* Community */}
        <ListItem disablePadding>
          <ListItemButton href="https://community.personalarch.com/" target="_blank">
            <ListItemIcon>
              <ForumIcon />
            </ListItemIcon>
            <ListItemText primary="Community" />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        {/* Envisioneer */}
        <ListItem disablePadding>
          <ListItemButton href="https://www.cadsoft.com" target="_blank">
            <ListItemIcon>
              <Box
                alt="Envisioneer Logomark"
                component="img"
                src={
                  process.env.NODE_ENV === 'development' ? 
                    "/assets/svg/marks/primary/envisioneer.svg" : 
                    "/wp-content/themes/personal-architect/assets/svg/marks/primary/envisioneer.svg"
                }
                sx={{width: 24, height: 24,}}
              />
            </ListItemIcon>
            <ListItemText primary="Envisioneer" />
          </ListItemButton>
        </ListItem>
        {/* Plnar */}
        <ListItem disablePadding>
          <ListItemButton href="/plnar/">
            <ListItemIcon>
              <Box
                alt="Plnar Logomark"
                component="img"
                src={
                  process.env.NODE_ENV === 'development' ? 
                    "/assets/svg/marks/primary/plnar.svg" : 
                    "/wp-content/themes/personal-architect/assets/svg/marks/primary/plnar.svg"
                }
                sx={{width: 24, height: 24,}}
              />
            </ListItemIcon>
            <ListItemText primary="Plnar" />
          </ListItemButton>
        </ListItem>
      </List>
    </Paper>
  )
}

export default FooterCol3